import { useEffect, useState } from "react";
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { Glass } from "./SuiteLayout";
import { Plans } from "../../lib/plans";

const label = (m) => new Date(`${m}-01T00:00:00Z`).toLocaleString(undefined, { month: "short", timeZone: "UTC" });

function Tip({ active, payload, label: m }) {
  if (!active || !payload?.length) return null;
  const r = payload[0].payload;
  return (
    <div className="rounded-lg border border-white/10 bg-slate-950/95 px-3 py-2 text-xs font-mono text-slate-300">
      <p className="text-white mb-1">{m}</p>
      <p className="text-cyan-300">Image processing · {r.processing}</p>
      <p className="text-purple-300">AI descriptions · {r.ai}</p>
      <p className="text-slate-500 mt-1">{r.batches} batches · {r.images} images</p>
    </div>
  );
}

export function UsageChart() {
  const [data, setData] = useState(null);
  useEffect(() => { Plans.usage(6).then(setData).catch(() => setData({ months: [], total: 0 })); }, []);
  const rows = (data?.months || []).map((r) => ({ ...r, label: label(r.month) }));
  return (
    <Glass className="p-6" data-testid="dashboard-usage-chart">
      <div className="flex items-end justify-between gap-3 mb-4">
        <div>
          <p className="font-mono text-[11px] tracking-[0.25em] text-purple-300">CREDIT USAGE · LAST 6 MONTHS</p>
          <p className="mt-1 text-sm text-slate-400">Net credits after refunds</p>
        </div>
        <p className="font-display text-3xl font-extrabold text-white" data-testid="usage-total">{data ? data.total : "—"}</p>
      </div>
      <div className="h-56">
        {data && (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={rows} margin={{ top: 4, right: 4, left: -20, bottom: 0 }}>
              <CartesianGrid stroke="rgba(255,255,255,0.06)" vertical={false} />
              <XAxis dataKey="label" tick={{ fill: "#94a3b8", fontSize: 11 }} axisLine={false} tickLine={false} />
              <YAxis allowDecimals={false} tick={{ fill: "#64748b", fontSize: 11 }} axisLine={false} tickLine={false} />
              <Tooltip content={<Tip />} cursor={{ fill: "rgba(34,211,238,0.06)" }} />
              <Legend wrapperStyle={{ fontSize: 11, color: "#94a3b8" }} />
              <Bar dataKey="processing" name="Image processing" stackId="c" fill="#22d3ee" radius={[0, 0, 4, 4]} />
              <Bar dataKey="ai" name="AI descriptions" stackId="c" fill="#a855f7" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
    </Glass>
  );
}
